import React, { useState, useEffect } from 'react';
import { createTheme, ThemeProvider } from '@material-ui/core/styles';
import Routes from 'components/Routes';
import dayjs from 'dayjs';
import { useDispatch, useSelector } from 'react-redux';
import { palette, typography } from './utils/Theme';
import jwt_decode from 'jwt-decode';
import setAuthToken from 'utils/setAuthToken';
import {
    ToastsContainer,
    ToastsContainerPosition,
    ToastsStore,
} from 'react-toasts';
import { logoutUser, setCurrentUser } from 'redux/actions/authActions';
import { getPublicStatus } from 'redux/actions/siteSettingsActions';
import './assets/css/neat.css';
import './App.css';
import './assets/css/theme.css';
import { lightTheme } from './lib/FormBuilder/themes';
import DialogContainer from 'catalyst/core/Dialog/DialogContainer';
import SnackbarContainer from 'catalyst/core/Snackbar/SnackbarContainer';
import api from 'api';
import { qsServerSelector } from 'redux/qsServer/selector';
import { setSideBarVisibility } from 'redux/actions/themeActions';
import Overlay from 'components/Overlay';
import { createHashHistory } from 'history';
import config from 'coeus.config';

const theme = createTheme({
    ...lightTheme,
    ...{
        palette,
        ...typography,
    },
});

export const history = createHashHistory();

const App = () => {
    const [loading, setLoading] = useState(true);
    const currentTime = dayjs().unix();
    const dispatch = useDispatch();
    const qsServer = useSelector(qsServerSelector);
    const tokenIsValid = (decoded) => {
        return dayjs(decoded.exp).diff(currentTime) > 0;
    };

    const setUpAccess = () => {
        const token = localStorage.jwtToken;

        if (!token) {
            setLoading(false);
            return;
        }

        const decoded = jwt_decode(token);

        if (!tokenIsValid(decoded)) {
            dispatch(logoutUser());
            setLoading(false);
            return;
        }

        setAuthToken(token);
        getUptoDateUser();
    };

    const getUptoDateUser = () => {
        api.users
            .currentUser()
            .then((data) => {
                dispatch(setCurrentUser(data));
                setLoading(false);
            })
            .catch((error) => {
                console.error(error);
                setLoading(false);
                ToastsStore.error('Failed to load user, please try again.');
            });
    };

    useEffect(() => {
        dispatch(getPublicStatus());
        setUpAccess();
        document.title = config?.title;
    }, []);

    useEffect(() => {
        if (window.innerWidth < 1000) {
            dispatch(setSideBarVisibility(false));
        }
    }, [qsServer]);

    return (
        <ThemeProvider theme={theme}>
            {!loading && <Routes />}
            <ToastsContainer
                store={ToastsStore}
                position={ToastsContainerPosition.TOP_CENTER}
            />
            <DialogContainer />
            <SnackbarContainer />
            <Overlay history={history} />
        </ThemeProvider>
    );
};

export default App;
